<a [hidden]="true" data-toggle="modal" [attr.data-target]="'#genericErrorModal-' + modalId" #genericErrorModalButton></a>
<div class="modal fade" tabindex="-1" role="dialog" [attr.id]="'genericErrorModal-' + modalId" aria-hidden="true" data-backdrop="static" #genericErrorModal>
    <div class="modal-dialog modal-dialog-centered assignment-creation-error-modal" role="document">
        <div class="modal-content p-3">
            <div class="modal-header p-0 d-flex flex-column justify-content-center align-items-center">
                <a class="cross ml-auto p-0 d-flex" href="javascript:void(0);" qid="close-error-btn" id="close-error-btn" data-dismiss="modal" [attr.data-target]="'#genericErrorModal-' + modalId">
                    <i class="nemo-font nemo-cross" aria-hidden="true"></i>
                    <span class="sr-only">{{'TEACHER.GENERIC_ERROR_MODAL.SCREEN_READER.CLOSE' | translate}}</span>
                </a>
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </div>
            <div class="modal-body text-center py-4 px-5">
                <span class="font-weight-normal"> {{'TEACHER.GENERIC_ERROR_MODAL.ERROR_MODAL_TEXT' | translate }}</span>
            </div>
            <div class="modal-footer d-flex flex-column p-0">
                <button type="button" class="pb-3 try-again-btn"  data-dismiss="modal"  data-dismiss="modal" [attr.data-target]="'#genericErrorModal-' + modalId" id="try-again-btn"
                    [attr.aria-label]="'TEACHER.GENERIC_ERROR_MODAL.TRY_AGAIN_BTN'| translate" qid="try-again-btn">
                    {{'TEACHER.GENERIC_ERROR_MODAL.TRY_AGAIN_BTN' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>